export default "__VITE_ASSET__BKfWgdRp__"